<template>
  <div class="mobile-menu">
    <div @click="$emit('closeMenu')" class="mobile-menu-item-container">
      <menu-item
        v-for="menuItem in navigationMenuItems"
        :key="menuItem.label"
        :label="menuItem[currentLanguage].label"
        :route="menuItem.route"
        :params="{slug:menuItem[currentLanguage].slug}"
      />
    </div>

    <div class="social-media-divider">
      <div class="plus-icon-container">
        <img src="../../assets/icons/plus-black.svg" alt="">
      </div>
      <div class="line"></div>
      <a href="https://www.linkedin.com/company/swiss-engineers-united" class="linked-in-icon-container">
        <img src="../../assets/icons/linkedin-icon.svg" alt="">
      </a>
    </div>

    <div class="mobile-menu-footer">
      <div class="footer-top">
        <div class="left-column">
          <div class="info-row">
            <img src="../../assets/icons/location-icon.svg" alt="">
            <div class="caption mobile-caption">Churerstrasse 54 CH-8808 Pfäffikon SZ</div>
          </div>
          <div class="info-row">
            <img src="../../assets/icons/call-icon.svg" alt="">
            <div class="caption mobile-caption">+41 (0)58 521 19 00</div>
          </div>
          <div class="info-row">
            <img src="../../assets/icons/world-icon-2.svg" alt="">
            <div class="caption mobile-caption">www.seu.ch
            </div>
          </div>
          <div class="info-row">
            <img src="../../assets/icons/mail-icon-2.svg" alt="">
            <div class="caption mobile-caption">info@seu.ch
            </div>
          </div>
        </div>
        <div class="right-column">
          <div @click="openPopup('ARRIVAL')" class="caps-medium">{{$t('footer.arrival')}}</div>
          <div @click="openPopup('MEDIA')" class="caps-medium">{{$t('footer.media')}}</div>
          <div @click="openPopup('NEWSLETTER')" class="caps-medium">{{$t('footer.newsletter')}}</div>
          <div @click="openPopup('JOBS')" class="caps-medium">{{$t('footer.jobs')}}</div>
          <div @click="openPopup('IMPRESSUM')" class="caps-medium">{{$t('footer.imprint')}}</div>
          <div @click="openPopup('TERMS')" class="caps-medium">{{$t('footer.terms')}}</div>
        </div>
      </div>
      <language-picker/>
    </div>
  </div>
</template>

<script>
import MenuItem from "/seu-frontend/components/MenuItem";
import navigationMenuItems from "../../services/data/navigationMenu";
import LanguagePicker from "/seu-frontend/components/LanguagePicker";
import {mapState} from "vuex";

export default {
  name: "MobileMenu",
  components: {LanguagePicker, MenuItem},
  computed: {
    ...mapState({
      currentLanguage: state => state.currentLanguage.toLowerCase(),
    }),
  },
  data() {
    return {
      navigationMenuItems
    }
  },
  props: {
    menuOpened: {
      type: Boolean,
    }
  },
  methods: {
    openPopup(popup) {
      this.$emit('openPopup', popup)
      // this.$emit('closeMenu')
    }
  }
}
</script>

<style lang="scss">
@import "MobileMenu.scss";
</style>
